import React from "react";
import { Link } from "react-scroll";
import "./image.scss";

const Image = () => {
  return (
    <div id="top-desktop">
      <Link to="video" smooth={true} duration={500}>
        <img src="top-desktop.png" alt="top-desktop" />
      </Link>
    </div>
  );
};

export default Image;
